import sdkProvider from "src/utilities/sdkProvider";
import { IDENTITY_TIMEOUT } from "src/app/constants";

export default async function getCustomerAccessToken() {
  const { getAccessToken } = await sdkProvider("identity");
  let timeout;

  try {
    return await Promise.race([
      new Promise((_, reject) => {
        timeout = setTimeout(() => {
          reject(new Error("Identity Timeout"));
        }, IDENTITY_TIMEOUT);
      }),
      getAccessToken(),
    ]);
  } finally {
    clearTimeout(timeout);
  }
}
